import React from 'react'
import { Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'
import { ICharacter } from '../../../../../../../../api/types/character'
import { BaseStatItem } from '../BaseStatItem/BaseStatItem'
import { useGlobalError } from '../../../../../../../../context/GlobalError'
import { useMutation } from '@tanstack/react-query'
import { mutationStatRoll } from '../../../../../../../../api/mutations'
import { extractMessage } from '../../../../../../../../utils'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      padding: theme.spacing(1),
      marginLeft: theme.spacing(1),
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
    },
  })
)

interface Props {
  char: ICharacter
  game_id?: number
  showChatTab?: () => void
  editable?: boolean
  onEditAttribute?: (name: string, newValue: string) => void
}

export const BaseStats: React.FC<Props> = ({
  char,
  game_id,
  showChatTab,
  editable,
  onEditAttribute,
}) => {
  const classes = useStyles()

  const { addError } = useGlobalError()
  const { mutate: rollMutation, isLoading: isMutating } = useMutation(
    (stat_attr: string) =>
      mutationStatRoll(char.id, { game_id: game_id || 0, stat_attr: stat_attr }),
    {
      onError: (err: any) => {
        addError(extractMessage(err) || 'Nie udało się wykonać rzutu', err?.status)
      },
      onSuccess: (data: any) => {
        showChatTab && showChatTab()
      },
    }
  )

  const handleRoll = (stat: string) => {
    if (!game_id) {
      return undefined
    }
    return () => rollMutation(stat)
  }

  return (
    <div className={classes.card}>
      <BaseStatItem
        editable={editable}
        isRolling={isMutating}
        onStatRoll={handleRoll('strength')}
        onEdit={v => onEditAttribute && onEditAttribute('strength', v)}
        name="Siła"
        value={char.strength}
      />
      <BaseStatItem
        editable={editable}
        isRolling={isMutating}
        onStatRoll={handleRoll('condition')}
        onEdit={v => onEditAttribute && onEditAttribute('condition', v)}
        name="Kondycja"
        value={char.condition}
      />
      <BaseStatItem
        editable={editable}
        isRolling={isMutating}
        onStatRoll={handleRoll('endurance')}
        onEdit={v => onEditAttribute && onEditAttribute('endurance', v)}
        name="Wytrzymałość"
        value={char.endurance}
      />
      <BaseStatItem
        editable={editable}
        isRolling={isMutating}
        onStatRoll={handleRoll('dexterity')}
        onEdit={v => onEditAttribute && onEditAttribute('dexterity', v)}
        name="Zręczność"
        value={char.dexterity}
      />
      <BaseStatItem
        editable={editable}
        isRolling={isMutating}
        onStatRoll={handleRoll('agility')}
        onEdit={v => onEditAttribute && onEditAttribute('agility', v)}
        name="Zwinność"
        value={char.agility}
      />
      <BaseStatItem
        editable={editable}
        isRolling={isMutating}
        onStatRoll={handleRoll('perception')}
        onEdit={v => onEditAttribute && onEditAttribute('perception', v)}
        name="Percepcja"
        value={char.perception}
      />
      <BaseStatItem
        editable={editable}
        isRolling={isMutating}
        onStatRoll={handleRoll('intelligence')}
        onEdit={v => onEditAttribute && onEditAttribute('intelligence', v)}
        name="Inteligencja"
        value={char.intelligence}
      />
      <BaseStatItem
        editable={editable}
        isRolling={isMutating}
        onStatRoll={handleRoll('wisdom')}
        onEdit={v => onEditAttribute && onEditAttribute('wisdom', v)}
        name="Mądrość"
        value={char.wisdom}
      />
      <BaseStatItem
        editable={editable}
        isRolling={isMutating}
        onStatRoll={handleRoll('charisma')}
        onEdit={v => onEditAttribute && onEditAttribute('charisma', v)}
        name="Charyzma"
        value={char.charisma}
      />
    </div>
  )
}
